// extracted by mini-css-extract-plugin
export default {"wrapper":"env-check_wrapper__aerhh","content":"env-check_content__zq-bc","notice":"env-check_notice__Vtby8","bottom":"env-check_bottom__3P70v","modal":"env-check_modal__Cp1zY"};